<template>
  <section>
    <HeroBanner
      title="Health"
      subtitle="Keep your Floof healthy wealthy and wise."
      background-color="is-danger"
      icon="heart-pulse"
    />

    <main role="main">
      <div
        v-for="(section, index) in productSections"
        :key="index"
        class="container section"
      >
        <article>
          <p class="title">{{ section.title }}</p>
          <p class="subtitle">{{ section.subtitle }}</p>
          <b-message v-if="section.alert" type="is-warning" has-icon>
            {{ section.alert }}
          </b-message>

          <div class="content">
            <p v-html="section.description" />

            <ProductList :product-category="section.productCategory" />
          </div>
        </article>
      </div>
    </main>
  </section>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
import ProductList from '@/components/ProductList'
import { getPageMeta } from '@/utils'

const meta = {
  pageTitle: 'Health',
  pageDescription:
    'To ensure your chinchilla stays happy and healthy, it is important to provide a proper diet, keep them well groomed and in a cool temperature.',
  pageURL: 'http://www.chinchillaessentials.com/health',
  pageImg:
    'https://www.chinchillaessentials.com/img/chinchilla_baby_and_mother.jpeg'
}

export default {
  name: 'Health',
  components: {
    HeroBanner,
    ProductList
  },
  metaInfo: () => getPageMeta(meta),
  data() {
    return {
      productSections: [
        {
          title: 'Food',
          subtitle: 'Feed the Floof only what they deserve.',
          description:
            'Food is key to your baby Floof’s growing needs, and throughout his/her adult life as well. It is important to get healthy food and provide your chinchilla with substantial nutrients. To start off your Floof’s health right, we provided you with some great food options at low prices from <a href="http://www.oxbowanimalhealth.com/products/species/chinchillas" target="_blank">Oxbow</a>.',
          productCategory: 'food'
        },
        {
          title: 'Temperature Control',
          subtitle: 'Make sure your Floof is at a comfortable temperature.',
          description: `
            <p>Chinchillas are prone to overheating, as they have very heavy coats and do not have sweat glands. This can lead to sickness or even death, so it’s important to keep your Floof in an air-conditioned environment around 65-70℉. Avoid placing your chinchilla in areas with direct sunlight, and leave shaded areas in your chinchilla’s cage for your chinchilla to stay under, such as a hut, linked below.</p>
            <p>Granite stone chillers are also a great option to make sure your chinchilla remains cool. These handy chillers automatically maintain a temperature under room temperature, preventing overheating or heat exhaustion. Provided below are a few places where you can purchase these granite stones for an affordable price.</p>
            <p>Signs of overheating include: red ears, heavy breathing, and laying on their side.</p>
            <p>If you notice any of these things happening, take action. Find any means to cool your chinchilla down and call a vet. Do not use ice or very cold water.</p>
          `,
          productCategory: 'temperature-control'
        },
        {
          title: 'Grooming',
          subtitle: 'Make sure your Floof is squeaky clean.',
          alert:
            'Warning: Do not attempt to wash your chinchilla. They will know instinctively how to clean themselves - getting their fur wet can be dangerous for your Floof.',
          description:
            'Because of their extremely dense fur, chins need regular dust baths to keep themselves clean. There is a special kind of dust that you should use. All you have to do is place about an inch of dust into a large container with enough space for your chinchilla to roll around in, and your Floof will do the rest. This should be done 2 to 3 times a week. Leave the dust bath in the cage for approximately an hour at a time; leaving it in longer than one hour will potentially cause the bath to become contaminated with feces.',
          productCategory: 'grooming'
        },
        {
          title: 'Supplements',
          subtitle: 'In case the Floof is sick or pregnant.',
          description: `
            <p>Chinchillas that are healthy do not require extra supplements, but they can be very helpful for a sick, stressed, or pregnant chinchilla.</p>
            <p><strong>Calcium</strong> is critical for chinchillas that have tooth disorders such as malocclusion. Low calcium levels will result in dark yellow teeth. Aim for your chinchilla to have dark orange teeth. Calcium is also an important supplement for chinchillas that are pregnant, as they quickly will be depleted through nursing.</p>
            <p><strong>Multivitamins</strong> are a great way to ensure a sick or stressed chinchilla obtains all of it’s essential vitamins and minerals when going through a tough time.</p>`,
          productCategory: 'supplements'
        },
        {
          title: 'Treats',
          subtitle: 'Spoil the Floof.',
          alert:
            'Chinchillas do NOT need treats in their diet. Giving them treats more than once a week is considered dangerous and can cause health issues or death.',
          description:
            'Treat time! Show your love and affection with treats from time to time. Treats can make your chinchilla happy, but they can also be used to reward good behavior. Just remember - always give treats in moderation.',
          productCategory: 'treats'
        }
      ]
    }
  }
}
</script>
